/*
var $ = require('jquery');
*/

var jQueryBridget = require('jquery-bridget');
var Masonry = require('masonry-layout');

jQueryBridget( 'masonry', Masonry, $ );


$(function(){
  var w = window.innerWidth ? window.innerWidth: $(window).width();
  if ( w > 768 ) {
    $("div.m-text-card-wrap").masonry({
      itemSelector: ".grid-l-4" || ".grid-m-4"
    });
  }

  $(window).resize(function(){
    $("div.m-text-card-wrap").masonry({
      itemSelector: ".grid-l-4" || ".grid-m-4"
    });
  });
});

$(function(){
  $('select.f-select').customSelect();
});

$(function(){

  var $heros = $('ul.m-heros');
  var $arrows         = $('div#arrows');
  var $next           = $arrows.children("div.slick-next");
  var $prev           = $arrows.children("div.slick-prev");

  var $heroSlick = $heros.slick({
    autoplay: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding: '-4.6%',
    variableWidth: true,
    appendArrows: $arrows
  });

  $next.click(function(){
    $heros.slick('slickNext');
  });

  $prev.click(function(){
    $heros.slick('slickPrev');
  });

});


$(function(){
  $.slidebars();
});
